import React from 'react'
import Layout from '../components/layout'
import { graphql, useStaticQuery, Link } from 'gatsby'
//import { GatsbyImage } from "gatsby-plugin-image"
import Seo from '../components/seo'

const Portatiles = () => {
  const data = useStaticQuery(
    graphql`
      {
        allWpPost(
          filter: {
            categories: { nodes: { elemMatch: { name: { eq: "portatiles" } } } }
          }
        ) {
          nodes {
            id
            title
            excerpt
            uri
            featuredImage {
              node {
                sourceUrl
                srcSet
                altText
              }
            }
          }
        }
      }
    `
  )

  const { allWpPost } = data

  return (
    <Layout>
      <Seo
        title='Extintores portátiles'
        description='Extintores portátiles para uso en el hogar y en cualquier otro espacio para prevenir la extensión de un incendio. La primera opción para defender su patrimonio contra el fuego.'
      />
      <div className='d-flex flex-wrap px-4 my-5'>
        <div className='text-center mx-auto'>
          <h1>EXTINTORES PORTÁTILES</h1>
          <p className='lead text-danger fw-bold'>
            ES TIEMPO DE QUE LA SEGURIDAD ESTÉ EN SUS MANOS
          </p>
        </div>
        <div className='d-flex flex-wrap col-12 col-md-10 mx-auto align-items-start justify-content-center'>
          {allWpPost.nodes.map(({ id, title, excerpt, featuredImage, uri }) => (
            <div
              key={id}
              className='col-12 col-md-3 border border-grey-light rounded m-1'
            >
              <img
                className='card-img-top p-3 img-fluid'
                src={featuredImage.node.sourceUrl}
                srcSet={featuredImage.node.srcSet}
                alt={featuredImage.node.altText}
              />
              {/* <GatsbyImage
                image={
                  featuredImage.node.localFile.childImageSharp.gatsbyImageData
                }
                alt={featuredImage.node.altText}
              /> */}
              <div className='card-body'>
                <p className='card-title text-uppercase text-center fw-bold lead fs-5 m-0 lh-1'>
                  {title}
                </p>
                <p className='card-text text-center ellipsis'>
                  {excerpt.replace(/(<([^>]+)>)/gi, ' ')}
                </p>
                <div className='d-grid gap-2'>
                  <Link className='btn btn-danger fs-6' type='button' to={uri}>
                    Ver detalles
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Portatiles
